import requestApi from '../../../utils/Request';
import { showErrorAlert, showSuccessAlert } from '../../../utils/AlertUtils';
import {
  requestCouponList,
  responseCouponList,
  failureCouponList,
  requestCouponAdd,
  responseCouponAdd,
  failureCouponAdd,
  requestCouponView,
  responseCouponView,
  failureCouponView,
  requestCouponDelete,
  responseCouponDelete,
  failureCouponDelete,
} from '../../slices/couponSlice/couponSlice';
import { COUPONSLIST } from 'utils/StaticApiEndpoints';
import { COUPON } from 'utils/StaticApiEndpoints';

///////// List Coupon Data //////////
export const ListCouponData = (payload = {}) => {
  return (dispatch) => {
    const {
      page = 1,
      limit = 10,
      search = '',
      isActive = '',
      couponType = '',
      startDate = null,
      endDate = null,
    } = payload;

    dispatch(requestCouponList());

    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (search) params.append('couponCode', search);
    if (isActive) params.append('isActive', isActive);
    if (couponType) params.append('couponType', couponType);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    // API integration:
    requestApi
      .get(`${COUPONSLIST}?${params.toString()}`)
      .then((response) => {
        // Handle the response structure: { success: true, data: { list: [], total: 0, ... } }
        dispatch(responseCouponList(response));
      })
      .catch((error) => {
        dispatch(failureCouponList(error));
        showErrorAlert(error?.message || 'Failed to load coupons');
      });
  };
};

///////// Add Coupon Data //////////
export const AddCouponData = (payload, navigate, callback) => {
  return (dispatch) => {
    dispatch(requestCouponAdd());
    requestApi
      .post(COUPON, payload)
      .then(() => {
        dispatch(responseCouponAdd());
        showSuccessAlert('Coupon added successfully');
        if (navigate) navigate('/admin/coupons');
        if (callback) callback();
      })
      .catch((error) => {
        dispatch(failureCouponAdd(error));
        showErrorAlert(error?.message || 'Failed to add coupon');
      });
  };
};

///////// View Coupon Data //////////
export const ViewCouponData = (couponId) => {
  return (dispatch) => {
    dispatch(requestCouponView());
    requestApi
      .get(`${COUPON}/${couponId}`)
      .then((response) => {
        dispatch(responseCouponView(response));
      })
      .catch((error) => {
        dispatch(failureCouponView(error));
        showErrorAlert(error?.message || 'Failed to load coupon details');
      });
  };
};

///////// Update Coupon Data //////////
export const UpdateCouponData = (couponId, payload, navigate, callback) => {
  return (dispatch) => {
    dispatch(requestCouponAdd());
    requestApi
      .put(`${COUPON}/${couponId}`, payload)
      .then(() => {
        dispatch(responseCouponAdd());
        showSuccessAlert('Coupon updated successfully');
        if (navigate) navigate('/admin/coupons');
        if (callback) callback();
      })
      .catch((error) => {
        dispatch(failureCouponAdd(error));
        showErrorAlert(error?.message || 'Failed to update coupon');
      });
  };
};

///////// Delete Coupon Data //////////
export const DeleteCouponData = (couponId, _payload = {}, callback) => {
  return (dispatch) => {
    dispatch(requestCouponDelete());
    requestApi
      .delete(`${COUPON}/${couponId}`)
      .then(() => {
        dispatch(responseCouponDelete());
        showSuccessAlert('Coupon deleted successfully');
        if (callback) callback();
      })
      .catch((error) => {
        dispatch(failureCouponDelete(error));
        showErrorAlert(error?.message || 'Failed to delete coupon');
      });
  };
};
